<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工部门</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="selectName" placeholder="输入部门名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

    </el-form>
    <!--列表-->
    <el-table  :data="tableData" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:50px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column  prop="TcStaffName" label="部门名称">
        </el-table-column>
        <!-- <el-table-column  prop="TcStaffTypeID" label="所属部门" >
        </el-table-column> -->
        <!-- <el-table-column  prop="TcStaffTypeID" label="所属门店" >
        </el-table-column> -->
        <!-- <el-table-column  prop="Phone" label="联系电话" >
        </el-table-column> -->
                <!-- <el-table-column  prop="Introduce" label="个人介绍" >
        </el-table-column> -->
        <el-table-column prop="addTime" label="创建时间" >
        </el-table-column>
        <el-table-column prop="ShopName" label="商户名称" >
        </el-table-column>
      <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" width="450" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button v-if="scope.row.Isdisable == 0" type="warning" plain size="mini" @click="handlejie(scope.row)">禁用</el-button>
           <el-button v-if="scope.row.Isdisable == 1" type="info" plain size="mini" @click="handlejie(scope.row)">解禁</el-button>
          <el-button size="mini" type="primary"  @click="handlePassword(scope.row)">修改密码</el-button>
          <el-button size="mini" type="success"  @click="handleChong(scope.row)">充值</el-button>
          <el-button size="mini" type="info" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <!-- <el-drawer :wrapperClosable= false title="添加部门" :visible.sync="editFormVisible" :direction="direction" size="30%">
   
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
   


      </el-form>
  
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
            @click="submitForm()"
            >保存</el-button
          >
        </div>
    </el-drawer> -->
    <el-dialog title="添加部门" :visible.sync="editFormVisible" width="40%" >
      <el-form label-width="120px" :model="editForm">
        <el-form-item label="部门名称:" prop="TcStaffName">
          <el-input size="small" v-model="editForm.TcStaffName" auto-complete="off" placeholder="请输入部门名称"  style="width: 215px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
    <!-- </el-dialog> -->
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="topass()">保存</el-button>
      </div>
    </el-dialog>
      <el-dialog title="充值" :visible.sync="chongShow" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="充值金额" prop="money">
          <el-input size="small" placeholder="请输入充值金额" v-model="money"  auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDmoney()">充值</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      formValidate: {
        mainImage: "",
      },
       direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      tableData:[],
      Pwd:'',
      editForm: {
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        token: localStorage.getItem('token')
      },
      // rules表单验证

      rules: {
        LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
      // this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

     async  getList(){
     this.tableLoading = true
    const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

    const crs = await getListManageLogin({
      LoginID:localStorage.getItem('ID'),
      token:localStorage.getItem('token'),

      pages:this.formInline.page,
      psize:this.formInline.limit
      
        })
        if(crs.orsuccess=='1'){
          this.tableLoading = false
          this.pageparm.total = crs.allcount
                      var list = crs.data
          list.forEach(items => {
       
            items.addTime = items.addTime.replace(/\//g, '-')
          //   items.addtime =  items.addtime.splice(0.6)
          });
          this.tableData = list 
          // this.tableData = crs.data
           loading.close();
        }else{
          this.tableLoading = false
           loading.close();
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },
    handlePassword(row){
      this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改',
        this.editForm.ManageLoginID = row.ID,
        this.editForm.LoginName = row.LoginName
        this.editForm.Phone= row.Phone
        this.editForm.Name= row.Name
        this.editForm.ShopName= row.ShopName
        this.editForm.pwd='123'
        this.editForm.money='123'
        // this.editForm.deptId = row.deptId
        // this.editForm.deptName = row.deptName
        // this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
         this.editForm.ManageLoginID = ''
        this.editForm.LoginName = ''
        this.editForm.Phone= ''
        this.editForm.Name= ''
        this.editForm.ShopName= ''
        this.editForm.pwd=''
        this.editForm.money=' '

      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.title == '添加'){
                this.add()
            }else {
                this.edit()
            }
        } else {
          return false
        }
      })
    },
 async    add(){
const crs = await addManageLogin({
  token:this.editForm.token,
LoginName:this.editForm.LoginName,
Phone:this.editForm.Phone,
Name:this.editForm.Name,
pwd:this.editForm.pwd,
money:this.editForm.money,
ShopName:this.editForm.ShopName,
})
        if(crs.orsuccess=='1'){
           this.$message({
            type: "success",
            duration:2000,
            message:'添加成功'
          });
          this.editFormVisible = false
          this.getList()
          // this.tableLoading = false
          // this.pageparm.total = crs.allcount
          // this.tableData = crs.data
          //  loading.close();
        }else{
          this.tableLoading = false
           loading.close();
            this.editFormVisible = false
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },
 async ADDmoney(){

const crs = await editManageLoginmoney({
  token:this.editForm.token,
  ManageLoginID:this.editForm.ManageLoginID,
  money: Number (this.money) +  Number(this.editForm.money),

})
        if(crs.orsuccess=='1'){
          
           this.$message({
            type: "success",
            duration:2000,
            message:'充值成功'
          });
          this.chongShow = false
          this.editFormVisible = false
          this.getList()
          // this.tableLoading = false
          // this.pageparm.total = crs.allcount
          // this.tableData = crs.data
          //  loading.close();
        }else{
          this.tableLoading = false
           loading.close();
            this.editFormVisible = false
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
          this.chongShow = false
       }

    },

 async topass(){
   if(this.Pwd == ''){
 this.$message({
            type: "error",
            duration:2000,
            message:'请输入密码'
          });
   } else {
const crs = await editManageLoginPwd({
  token:this.editForm.token,
  ManageLoginID:this.editForm.ManageLoginID,
  Pwd:this.Pwd,

})
        if(crs.orsuccess=='1'){
          
           this.$message({
            type: "success",
            duration:2000,
            message:'修改成功'
          });
          this.passShow = false
          this.editFormVisible = false
          this.getList()
   
        }else{

           this.passShow  = false
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
          this.chongShow = false
       }
   }


    },


 async edit(){
const crs = await editManageLogin({
  token:this.editForm.token,
   ManageLoginID:this.editForm.ManageLoginID,
  LoginName:this.editForm.LoginName,
  Phone:this.editForm.Phone,
  Name:this.editForm.Name,
  pwd:this.editForm.pwd,
  money:this.editForm.money,
  ShopName:this.editForm.ShopName,
})
        if(crs.orsuccess=='1'){
           this.$message({
            type: "success",
            duration:2000,
            message:'修改成功'
          });
          this.editFormVisible = false
          this.getList()
          // this.tableLoading = false
          // this.pageparm.total = crs.allcount
          // this.tableData = crs.data
          //  loading.close();
        }else{
          this.tableLoading = false
           loading.close();
            this.editFormVisible = false
          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },
    async delete(row){
 const crs = await delManageLogin({
      // LoginID:localStorage.getItem('ID'),
      ManageLoginID:row.ID,
      token:localStorage.getItem('token'),
        })
        if(crs.orsuccess=='1'){
           this.$message({
            type: "success",
            duration:2000,
            message:'删除成功'
          });
            this.getList()
        }else{

          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },

    handlejie(row) {
      if(row.Isdisable == 0){
 this.$confirm('确定要禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie(row)
        })
        .catch(() => {
          
        })
      } else {
this.$confirm('确定要解禁吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie1(row)
        })
        .catch(() => {
          
        })
      }
 
     
    },
  async jie(row){
 const crs = await editManageLoginIsdisable({
      // LoginID:localStorage.getItem('ID'),
      ManageLoginID:row.ID,
      token:localStorage.getItem('token'),
      Isdisable:1,
        })
        if(crs.orsuccess=='1'){
           this.$message({
            type: "success",
            duration:2000,
            message:'禁用成功'
          });
            this.getList()
        }else{

          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },
 async jie1(row){
 const crs = await editManageLoginIsdisable({
      // LoginID:localStorage.getItem('ID'),
      ManageLoginID:row.ID,
      token:localStorage.getItem('token'),
      Isdisable:0,
        })
        if(crs.orsuccess=='1'){
           this.$message({
            type: "success",
            duration:2000,
            message:'解禁成功'
          });
            this.getList()
        }else{

          this.$message({
            type: "error",
            duration:2000,
            message:crs.Msg
          });
       }
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/personnel/section.vue